module.exports = __webpack_public_path__ + "img/ski_cos7.7ffff725.png";